import React from 'react';
import { Select as AntSelect } from 'antd';

/**
 * Wrapper component for Ant Design Select
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Select functionality and sub-components.
 * 
 * @component
 * @example
 * import { Select } from '../GeneralComponents/ui';
 * 
 * const { Option } = Select;
 * 
 * <Select defaultValue="lucy" style={{ width: 120 }}>
 *   <Option value="jack">Jack</Option>
 *   <Option value="lucy">Lucy</Option>
 *   <Option value="disabled" disabled>Disabled</Option>
 *   <Option value="Yiminghe">yiminghe</Option>
 * </Select>
 * 
 * // With OptGroup
 * <Select>
 *   <Select.OptGroup label="Manager">
 *     <Option value="jack">Jack</Option>
 *   </Select.OptGroup>
 * </Select>
 * 
 * @see https://ant.design/components/select/ - Ant Design Select documentation
 */
const Select = (props) => {
  return <AntSelect {...props} />;
};

// Preserve Select sub-components
Select.Option = AntSelect.Option;
Select.OptGroup = AntSelect.OptGroup;

export default Select;

